<template>
  <div class="hero">
    <div class="kontejner">
      <div class="dan">
        <div class="datum">Petak 25.4.</div>
        <div
          class="vreme"
          style="
            font-weight: 700;
            padding: 10px;
            border-bottom: 1px solid black;">
          10h Svečano otvaranje
        </div>
        <div class="vreme" style="display: grid; grid-template-columns: 1fr 1fr; align-items: center; text-align: center;">
                <p>11:00 - 15:00h</p>
                <p>15:30 - 19:30h</p>
        </div>
        <div class="predavanja">
          <div class="predavanje1">
            <p class="naslov">Od CV-a do zaposlenja...</p>
            <p class="predavac">Branislav Cvenić - Startuj Infostud</p>
            <p class="opis">
              Ukoliko te zanima koji su najvažniji koraci od pisanja CV-ja do
              zaposlenja, onda je ova radionica prava za tebe! - Od pisanja
              kvalitetnog CV-ja i motivacionog pisma, preko pripreme za intervju
              do predstavljanja poslodavcu. Dodatni deo treninga činiće i
              radionica na kojoj ćeš moći da izradiš svoj CV uz komentare i
              savete, kao i simulacija razgovora za posao kroz koju ćeš moći da
              prođeš u realističnom okruženju. Vidimo se na Akademiji mekih
              veština!
            </p>
          </div>
          <div class="predavanje2">
            <p class="naslov">Produktivnost</p>
            <p class="predavac">Lea Popović i Sara Gojković</p>
            <p class="opis">
              Koliko puta si pomislio/la: "Imam previše obaveza, a premalo
              vremena"? Možda ti ne treba više motivacije, već bolja strategija.
              <br /><br />
              Na ovom treningu ne pričamo o tome kako da "radiš više", već kako
              da radiš pametnije. Kako da postaviš ciljeve koji te pokreću. Kako
              da pronađeš svoj ritam i organizuješ dan tako da je u potpunosti u
              tvojim rukama.
              <br /><br />
              Vreme je da napraviš prvi korak ka uspostavljanju potpune kontrole
              nad svojim radom i vremenom. Vidimo se na treningu. ⏳🚀
            </p>
          </div>
        </div>
      </div>

      <div class="dan">
        <div class="datum">Subota 26.4.</div>
        <div class="vreme" style="display: grid; grid-template-columns: 1fr 1fr; align-items: center; text-align: center;">
                <p>11:00 - 15:00h</p>
                <p>15:30 - 19:30h</p>
        </div>
        <div class="predavanja">
          <div class="predavanje1">
            <p class="naslov">Liderstvo</p>
            <p class="predavac">Sara Gojković i Anđela Gazdić</p>
            <p class="opis">
              Biti lider ne znači imati sve odgovore, već znati kako da
              inspirišeš, slušaš i usmeravaš druge. 💡 Ova sesija pruža priliku
              mladima da istraže šta liderstvo zaista znači u savremenom svetu,
              zašto je važan način na koji komuniciraju, sarađuju i razvijaju
              odnose, i kako mogu da izgrade samopouzdanje u vođenju, čak i kada
              još uče i rastu. 🍀 Kroz razgovor i razmenu iskustava, učesnici će
              bolje razumeti svoju ulogu kao budući lideri — u zajednici, timu
              ili bilo kom okruženju koje ih čeka. 💫 <br /><br />
              Zato te pozivamo da nam se pridružiš na ovogodišnjem SSA i
              unaprediš svoje meke veštine! 🚀
            </p>
          </div>
          <div class="predavanje2">
            <p class="naslov">Kad sve krene nizbrdo - sklizni sa stilom.</p>
            <p class="predavac">Sonja Vojnović i Antonija Monar</p>
            <p class="opis">
              Stres? Jači nego Wi-Fi. Život? Brži od deadline-a. Ti? Na ivici,
              ali maskiraš to "sve je super" facom. <br /><br />
              Ako ti je poznat osećaj da gori svet, inbox i ti istovremeno – ova
              radionica je baš za tebe. Ne nudimo reiki ni kristale (žao nam je
              Slavice), ali nudimo: <br />✅ Kako da prepoznaš kad ti stres tiho
              pušta korenje, <br />✅ Šta možeš da uradiš kad se osećaš kao da
              ćeš eksplodirati, <br />✅ Zašto tvoje emocije nisu "previše" već
              potpuno validne, <br />✅ Gde ti je zapravo kontrola nad
              sopstvenim životom – i kako da je uzmeš nazad. <br /><br />
              Prijavi se, spusti gard i nauči kako da budeš dobro – čak i kad
              oko tebe sve vrišti.
            </p>
          </div>
        </div>
      </div>

      <div class="dan">
        <div class="datum">Nedelja 27.4.</div>
        <div class="vreme" style="display: grid; grid-template-columns: 1fr 1fr; align-items: center; text-align: center;">
                <p>11:00 - 15:00h</p>
                <p>15:30 - 19:30h</p>
        </div>
        <div class="predavanja">
          <div class="predavanje1">
            <p class="naslov">Moć reči i govora tela: Pregovaračka magija!</p>
            <p class="predavac">Darija Knežević i Ermin Mujanović</p>
            <p class="opis">
              Da li si ikada poželeo/la da možeš da pročitaš misli sagovornika
              ili da ga uveriš da vidi stvari iz tvoje perspektive? Na ovoj
              interaktivnoj sesiji otkrivamo tajne pregovaranja, snagu govora
              tela i moć storytelling-a! Kroz zabavne primere i dinamične vežbe,
              nauči kako da dominiraš razgovorom, osvojiš pažnju i ostaviš
              neizbrisiv utisak. Bilo da vodiš poslovne pregovore, tražiš
              povišicu ili jednostavno želiš da komuniciraš bolje – ova sesija
              će ti dati alate da briljiraš!
              <br /><br />
              🔹 Kako reći pravu stvar u pravo vreme?
              <br />
              🔹 Koje neverbalne signale šalješ (i primaš) nesvesno?
              <br />
              🔹 Kako ispričati priču koja ostavlja bez daha?<br> <br> Dođi, nauči i
              pregovaraj kao šampion! 
            </p>
          </div>
          <div class="predavanje2">
            <p class="naslov">
              Prezentacione veštine: Svesno i kreativno korišćenje pokreta i
              glasa
            </p>
            <p class="predavac">Andriana Takić</p>
            <p class="opis">
              Kako koristimo svoj glas dok izlažemo neku ideju pred drugima? Da
              li nas telo u toj ideji podržava ili sputava? I kako možemo da
              budemo prisutniji i sigurniji u tom procesu?
              <br /><br />
              Način na koji komuniciramo često je važan koliko i sadržaj koji
              prenosimo. Glas i pokret su naši osnovni alati izražavanja, a kada
              ih koristimo svesno, postajemo ubedljiviji, autentičniji i
              povezaniji sa sobom i publikom.
              <br /><br />
              Tokom ovog treninga, upoznaćeš se sa osnovnim elementima govornog
              glasa, kao i sa telesnim aspektima komunikacije, uključujući
              držanje, pogled, gestikulaciju i kretanje u prostoru. Kroz
              praktične vežbe, grupne interakcije i mini nastupe, razvijaćeš
              svoju prezentacionu prisutnost, kao i sposobnost da komuniciraš
              jasno, autentično i kreativno.
            </p>
          </div>
        </div>
        <div class="vreme" style="padding: 5px; border-top: 1px solid black;">
            <p>20h Svečano zatvaranje</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.hero {
  background-image: url("../assets/home_hero_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  height: 100%;
  left: 0;
  right: 0;
  font-size: 17px;
  padding-top: 10%;
  padding-bottom: 10%;
}

@media (max-width: 768px) {
  .hero {
    background: #11998e;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
    height: 100%;
    left: 0;
    right: 0;
    font-size: 17px;
    padding-top: 10%;
    padding-bottom: 10%;
  }
}

.kontejner {
  display: block;
  margin-left: 15px;
  margin-right: 15px;
}

.dan {
  margin-bottom: 40px;
  max-width: 800px;
  height: 100%;
  border: 1px solid black;
  border-radius: 20px;
  overflow: hidden;
  margin-left: 10px;
  margin-right: 10px;
  box-shadow: 5px 5px 4px rgba(0, 0, 0, 3);
  margin-left: auto;
  margin-right: auto;
}

.datum {
  background-color: #24888e;
  font-weight: 700;
  padding: 5px;
}

.vreme {
  font-weight: 700;
  background-color: #c8efe1;
}

.predavanja {
  display: flex;
  justify-content: space-around;
}

.predavanja div {
  justify-content: center;
  width: 50%;
  padding: 10px 20px;
}

.predavanje1 {
  background-color: #11998e;
}

.predavanje2 {
  background-color: #38ef7d;
}

.naslov {
  font-weight: 700;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 20px;
  line-height: 1;
}

.predavac {
  font-weight: 600;
  margin-top: 5px;
  margin-bottom: 20px;
}
.opis {
  text-align: justify;
}

@media (max-width: 1100px) {
  .hero {
    padding-top: 120px;
  }
}

@media (max-width: 768px) {
  .hero {
    font-size: 14px;
  }

  .naslov {
    font-size: 16px;
  }
}

@media (max-width: 479px) {
  .naslov {
    font-size: 14px;
  }

  .hero {
    font-size: 12px;
  }

  .predavanja div {
    padding: 5px 10px;
  }
}
</style>
